module.exports = {
          srcSet: __webpack_public_path__ + "bccf0e3ce168b7acf3349d96f520f3d6-60.png"+" 60w",
          images:[ {path: __webpack_public_path__ + "bccf0e3ce168b7acf3349d96f520f3d6-60.png",width: 60,height: 60}],
          src: __webpack_public_path__ + "bccf0e3ce168b7acf3349d96f520f3d6-60.png",
          toString:function(){return __webpack_public_path__ + "bccf0e3ce168b7acf3349d96f520f3d6-60.png"},
          
          width: 60,
          height: 60
        }